import { useState, useEffect } from "react";

export default function useFadeIn() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasLoaded = sessionStorage.getItem("hasLoaded");
    if (!hasLoaded) {
      setIsVisible(true);
      sessionStorage.setItem("hasLoaded", "true");
    } else {
      setIsVisible(true);
    }
  }),
    [];

  return isVisible;
}
